/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_Text_RequestInputs */

const en_mcp_demo_text_request = /** @type {(inputs: Mcp_Demo_Text_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send this summary to Listening so I can hear it on my walk.`)
};

const es_mcp_demo_text_request = /** @type {(inputs: Mcp_Demo_Text_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envía este resumen a Listening para escucharlo mientras camino.`)
};

/**
* | output |
* | --- |
* | "Send this summary to Listening so I can hear it on my walk." |
*
* @param {Mcp_Demo_Text_RequestInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_text_request = /** @type {((inputs?: Mcp_Demo_Text_RequestInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_Text_RequestInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_text_request(inputs)
	return en_mcp_demo_text_request(inputs)
});